import type { FaireProductEntity } from "../../entity_types/product";

export const p_fvj5hd7svu: FaireProductEntity = {
  token: "p_fvj5hd7svu",
  type: "product",
  name: "Peppermint Bark Bar - Christmas Holiday Limited Batch",
  brandToken: "b_e6md0h54",
  brandName: "Raaka Chocolate",
  imageUrl:
    "https://cdn.faire.com/fastly/c872e7327f07987b31c318b798ba3a9eca8bb1d663e538c52f53d3df0017ec52.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5d2955fc7fc7b952cdd8c0e915a6ddfe7e73c0e3e2a45be54fc33370d62d78bb.jpeg",
    "https://cdn.faire.com/fastly/7f40e0130824d89fa319f214439e221a4fc13647d048f73600b4ca00567e589f.png",
    "https://cdn.faire.com/fastly/ebc79fd6362e2ceba06c1648789acc4010e53438fac960f9cbb678aeb65007d6.png",
    "https://cdn.faire.com/fastly/b27d05462d9987a46ffff8e6bccbea9931b074635717085f51c0e056cb245c8c.jpeg",
  ],
  priceDollars: 5.02,
  description:
    "CAN WE GET A HO HO HO?\n\nThe all-in-one holiday special: peppermint-infused dark chocolate layered with creamy white chocolate, sprinkled with crushed candy cane. Sheer winter cheer. May incite carolling. The perfect Christmas stocking stuffer and holiday candy treat.\n\n52% CACAO",
  tags: [],
  msrpDollars: 10,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:52:19.234Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
